var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.typeClass,attrs:{"title":_vm.title},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("iconBefore"),_vm._v(" "+_vm._s(_vm.title)+" "),_vm._t("iconAfter")],2)}
var staticRenderFns = []

export { render, staticRenderFns }